// PopupEmailConfirmation Component

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Popover from '../../common/popover/popover.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'

class PopupEmailConfirmation extends Component {
  constructor (props) {
    super(props)

    this.state = {
      active: false
    }
  }

  static get propTypes () {
    return {
      onClick: PropTypes.func,
      target: PropTypes.object
    }
  }

  static get defaultProps () {
    return {
      onClick: null,
      target: null
    }
  }

  show () {
    this.setState({ active: true })
  }

  hide () {
    this.setState({ active: false })
  }

  render () {
    const classes = classnames('popup-email-confirmation popup-form', {
      active: this.state.active
    })

    return (
      <Popover
        className='popup-emailconfirmation'
        placement='bottom'
        container={this}
        target={this.props.target}
        show={this.state.active}
        onHide={this.hide.bind(this)}
      >
        <div className={classes}>
          <div className='popupcont' onClick={this._onClick.bind(this)}>
            <div className='inner'>
              <div className='iconbar'>
                <IconButton
                  icon='dialog-warning'
                  className='modal popupalert'
                  canHover={false}
                />
              </div>
              <div className='header'>
                <h2 className='title'>
                  <IntlMessage ident='common.dashboard.titleEmailConfirmationRequired' />
                </h2>
                <IconButton
                  icon='popup-close'
                  className='modal'
                  canHover
                  onClick={this._onClickClose.bind(this)}
                />
              </div>
              <div className='content'>
                <div className='info'>
                  <IntlMessage ident='common.dashboard.emailValidationInfo' />
                  <IconButton
                    icon='warning-next'
                    className='modal popupalert'
                    canHover={false}
                    onClick={this._onClick.bind(this)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Popover>
    )
  }

  /* Event handlers */
  _onClickClose (ev) {
    ev.preventDefault()
    ev.stopPropagation()
    this.hide()
  }

  _onClick (ev) {
    ev.preventDefault()

    if (this.props.onClick) {
      this.props.onClick()
    }
  }
}

export default PopupEmailConfirmation
